import { ReactElement, useCallback, useState } from 'react';

import { PromiseVoidFunction, useBoolean } from '@dreryk/react-common';

import { ProAuctoreAndProFamiliaMissingContactDetailsModal } from './ProAuctoreAndProFamiliaMissingContactDetailsModal';
import { ProAuctoreAndProFamiliaMissingDoctorContactDetails } from './ProAuctoreAndProFamiliaMissingContactDetailsModal.types';

type ProAuctoreAndProFamiliaMissingContactDetailsOuputModalProps = {
   onMissingDetailsUpdated: PromiseVoidFunction;
};

type UseProAuctoreAndProFamiliaMissingContactDetailsModalOutput = {
   openProAuctoreAndProFamiliaMissingContactDetailsModal: (
      missingDetails: ProAuctoreAndProFamiliaMissingDoctorContactDetails
   ) => void;
   renderProAuctoreAndProFamiliaMissingContactDetailsModal: (
      props: ProAuctoreAndProFamiliaMissingContactDetailsOuputModalProps
   ) => ReactElement;
};

export const useProAuctoreAndProFamiliaMissingContactDetailsModalOpener = (): UseProAuctoreAndProFamiliaMissingContactDetailsModalOutput => {
   const [missingContactDetails, setMissingContactDetails] = useState<
      ProAuctoreAndProFamiliaMissingDoctorContactDetails | undefined
   >(undefined);
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean();

   const handleModalOpen = useCallback(
      (missingDetails: ProAuctoreAndProFamiliaMissingDoctorContactDetails) => {
         setMissingContactDetails(missingDetails);
         openModal();
      },
      [openModal]
   );

   return {
      renderProAuctoreAndProFamiliaMissingContactDetailsModal: (props) => (
         <>
            {modalOpened && missingContactDetails ? (
               <ProAuctoreAndProFamiliaMissingContactDetailsModal
                  missingDetails={missingContactDetails}
                  onMissingDetailsUpdated={props.onMissingDetailsUpdated}
                  onClose={closeModal}
               />
            ) : null}
         </>
      ),
      openProAuctoreAndProFamiliaMissingContactDetailsModal: handleModalOpen,
   };
};
